// @ README
// Styles to be de-duped - pulled from style-guide and clashing with existing
// Refactored during re-build

export const BREAK_POINTS = {
  Min: {
    SM: '576px',
    MD: '768px',
    LG: '992px',
    XL: '1200px',
  },
  Max: {
    SM: '575px',
    MD: '767px',
    LG: '991px',
    XL: '1199px',
  },
};
